export interface InvoiceItem {
  id: string;
  description: string;
  quantity: number;
  unitPrice: number;
}

export interface InvoiceData {
  invoiceNumber: string;
  invoiceDate: string;
  dueDate: string;

  fromCompany: string;
  fromOrgNumber: string;
  fromAddress: string;
  fromCity: string;
  fromEmail: string;
  fromPhone: string;

  toCompany: string;
  toAddress: string;
  toCity: string;
  toEmail: string;

  items: InvoiceItem[];
  notes: string;
  taxRate: number;
}

export const defaultInvoiceData: InvoiceData = {
  invoiceNumber: "INV-001",
  invoiceDate: new Date().toISOString().split("T")[0],
  dueDate: new Date(Date.now() + 30 * 86400000).toISOString().split("T")[0],

  fromCompany: "Solvy AB",
  fromOrgNumber: "559443-8870",
  fromAddress: "Kyrkogatan 16 b",
  fromCity: "852 34 Sundsvall",
  fromEmail: "hello@solvy.se",
  fromPhone: "072-201 70 93",

  toCompany: "",
  toAddress: "",
  toCity: "",
  toEmail: "",

  items: [{ id: crypto.randomUUID(), description: "", quantity: 1, unitPrice: 0 }],
  notes: "",
  taxRate: 25,
};

export function calculateSubtotal(items: InvoiceItem[]): number {
  return items.reduce((sum, item) => sum + item.quantity * item.unitPrice, 0);
}

export function calculateTax(subtotal: number, taxRate: number): number {
  return subtotal * (taxRate / 100);
}

export function calculateTotal(subtotal: number, tax: number): number {
  return subtotal + tax;
}
